import React from 'react'
import { Helmet } from 'react-helmet-async'
import keywords from "../seo/keywords";

const CustomHelmet = (props) => {
    const { title, desc, url } = props


    const fullTitle = `Connect Homes${title ? " - " + title : ""}`;
    const description = desc || "Connect Homes offers modern, sustainable, prefab houses built for smarter, greener living in Connecticut and beyond.";
    const image = "https://www.connecthomes.co/og-image.png";
    const pageUrl = url || "https://www.connecthomes.co";


    return (
        <Helmet>
            <meta charSet="utf-8" />

            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords.join(', ')} />

        </Helmet>
    )
}

export default CustomHelmet